/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Summary of an VMUA approval request and its latest decision, returned by the list API.
 */
export interface VmuaApprovalSummary { 
    /**
     * Unique identifier of the approval request.
     */
    requestId?: string;
    /**
     * The entity (e.g. vCenter UUID) the operation targets.
     */
    entityId?: string;
    /**
     * Key ID used to encrypt the original request.
     */
    keyId?: string;
    /**
     * The operation that was requested (e.g. DELETE_PG_SNAPSHOTS).
     */
    operation?: string;
    /**
     * Resource targeted by the operation.
     */
    resourceId?: string;
    /**
     * The user who initiated the request on the SnapService side.
     */
    requestedBy?: string;
    /**
     * Timestamp when the request was issued by SnapService.
     */
    requestedAt?: Date;
    /**
     * Timestamp after which the approval request is no longer valid.
     */
    expiresAt?: Date;
    /**
     * Email of the approver who made the latest decision.
     */
    approvedBy?: string;
    /**
     * The latest decision made on this request.
     */
    decision?: VmuaApprovalSummary.DecisionEnum;
    /**
     * Timestamp when the decision was recorded.
     */
    decidedAt?: Date;
}
export namespace VmuaApprovalSummary {
    export type DecisionEnum = 'APPROVE' | 'DENY';
    export const DecisionEnum = {
        APPROVE: 'APPROVE' as DecisionEnum,
        DENY: 'DENY' as DecisionEnum
    };
}


